// extracted by mini-css-extract-plugin
export default {"titles":"styles_titles__0LrQG","magazine":"styles_magazine__Daek-","primaryMagazine":"styles_primaryMagazine__HKWps","removedMagazine":"styles_removedMagazine__ndtpv"};